<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
          <div style="width:100%">
            <div class="card mt-2">
              <div class="card-body">
                <div class="row">
                  <div class="col-md-12">
                    <div class="alert alert-info" role="alert">
                      Pembayaran 2 bulan juga akan tampil disini ya gan.
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    
                    <div class="row mb-2">
                      <button @click="cariTelepon()" class="btn btn-warning">Cari Pelanggan</button>
                      <button @click="byAdmin()" class="btn btn-success">Pilih By Admin</button>
                      <button @click="filterCustom()" class="btn btn-info">Filter</button>
                    </div>
                    <div class="row">
                      <div class="col-md-2 cariByTanggal" v-show="cariByTelepon">
                          <div class="form-group">
                          <input type="text" class="form-control" placeholder="Nama User (Kosongkan untuk muncul semua user)" style="width:100%" v-model="telepon" />
                        </div>
                      </div>
                      <div class="col-md-2" v-show="cariByTelepon">
                        <div class="form-group">
                          <select class="form-control" v-model="bulan" placeholder="Pilih Bulan...">
                            <option value="" disabled selected>Pilih Bulan</option>
                            <option value="01">Januari</option>
                            <option value="02">Februari</option>
                            <option value="03">Maret</option>
                            <option value="04">April</option>
                            <option value="05">Mei</option>
                            <option value="06">Juni</option>
                            <option value="07">Juli</option>
                            <option value="08">Agustus</option>
                            <option value="09">September</option>
                            <option value="10">Oktober</option>
                            <option value="11">November</option>
                            <option value="12">Desember</option>
                          </select>
                        </div>
                      </div>
                      <div class="col-md-3 cariByTanggal" v-show="cariByTelepon">
                          <div class="form-group">
                          <button  class="btn btn-primary" @click="cariTeleponApi()">Cari</button>
                        </div>
                      </div>
                      <div class="cariByTanggal" v-show="filterCustomBox">
                        <div class="form-group">
                          <vuejs-datepicker :format="customFormatter" placeholder="Dari Tanggal..." style="width:100%" v-model="dariTanggal"></vuejs-datepicker>
                        </div>
                      </div>
                      <div class="cariByTanggal" v-show="filterCustomBox">
                        <div class="form-group">
                          <vuejs-datepicker :format="customFormatter" placeholder="Sampai Tanggal..." style="width:100%" v-model="sampaiTanggal"></vuejs-datepicker>
                        </div>
                      </div>
                      <div class="cariByTanggal" v-show="filterCustomBox">
                        <div class="form-group">
                          <input type="text" class="form-control" placeholder="Area..." style="width:100%" @focus="showArea()" v-model="areaName" />
                        </div>
                      </div>
                      <div class="cariByTanggal" v-show="filterCustomBox">
                        <div class="form-group">
                          <button  class="btn btn-primary" @click="cariCustom">Cari</button>
                        </div>
                      </div>
                    </div>

                  </div>
                  <div class="col-md-4">
                    <p class="card-title text-right">Total Pembayaran</p>
                    <h4 class="card-title text-right"><strong>{{ribu(totalHistory)}}</strong></h4>
                  </div>
                  <div class="col-md-2 text-right">
                    
                    <download-excel
                        style = "padding: 0"
                        class   = "btn btn-default"
                        :data   = "json_datapelanggan"
                        :fields = "json_fieldspelanggan"
                        worksheet = "My Worksheet"
                        :before-generate = "startDownload"
                        :title = "judulDoc"
                        :name    = "nameDoc">
                    
                      <button type="button" class="btn btn-primary">EXPORT</button>
                    </download-excel>

                  </div>
                </div>
                <div class="table-responsive">
                  <table class="table">
                    <thead class=" text-info">
                      <th>No.</th>
                      <th>Nama</th>
                      <th>Paket</th>
                      <th>Area</th>
                      <th>Biaya</th>
                      <th>Bulan & Tanggal</th>
                      <th>Admin By</th>
                      <th>Aksi</th>
                    </thead>
                    <tbody v-show="loading">
                      <tr>
                        <td colspan="8"><Loading></Loading></td>
                      </tr>
                      <tr>
                        <td colspan="8"><Loading></Loading></td>
                      </tr>
                      <tr>
                        <td colspan="8"><Loading></Loading></td>
                      </tr>
                    </tbody>
                    <tbody v-show="!loading">
                      <tr v-if="pelanggan.length == 0"><td></td><td>Tidak ada Data</td></tr>
                      <tr v-for="(u, index) in pelanggan">
                        <td>{{ index+1 }}</td>                        
                        <td>{{ u.user.unama }}</br>{{ u.user.wa }}</td>
                        <td>{{ u.user.pnama }}</br>Tagihan Tgl {{ u.user.tanggal_tagihan }}</td>
                        <td>{{ u.area }}</td>
                        <td>{{ ribu(u.user.paket_tarif) }}</td>
                        <td>
                          <span class="text-info">{{BulanOnly(u.user.tanggal)}}</span> 
                          <br> 
                          {{ tglIndo(u.user.bayar_tanggal) +" || " + isNullText(u.user.bayar_jam) }}
                        </td>
                        <td>
                          <span v-if="u.user.stat_via_online == null"> Kang Tagih {{ u.user.by_admin }}</span>
                          <span v-else class="text-uppercase">
                            <img class="icon" src="@/assets/qris.png" alt="" style="height: 35px;" v-if="u.user.via == 'qris'">
                            <img class="icon" src="@/assets/alfamidi.png" alt="" style="height: 35px;" v-else-if="u.user.via == 'alfamidi'"> 
                            <img class="icon" src="@/assets/indomaret.png" alt="" style="height: 35px;" v-else-if="u.user.via == 'indomaret'"> 
                            <img class="icon" src="@/assets/indomaret.png" alt="" style="height: 35px;" v-else-if="u.user.via == 'INDOMARET'"> 
                            <img class="icon" src="@/assets/alfamart.png" alt="" style="height: 35px;" v-else-if="u.user.via == 'ALFAMART'"> 
                            <img class="icon" src="@/assets/permata.png" alt="" style="height: 35px;" v-else-if="u.user.via == 'PERMATA'"> 
                            <img class="icon" src="@/assets/bni.png" alt="" style="height: 35px;" v-else-if="u.user.via == 'BNI'"> 
                            <img class="icon" src="@/assets/bri.png" alt="" style="height: 35px;" v-else-if="u.user.via == 'BRI'"> 
                            <img class="icon" src="@/assets/mandiri.png" alt="" style="height: 35px;" v-else-if="u.user.via == 'MANDIRI'"> 
                            <img class="icon" src="@/assets/ovo.png" alt="" style="height: 35px;" v-else-if="u.user.via == 'ovo'"> 
                            <img class="icon" src="@/assets/dana.png" alt="" style="height: 35px;" v-else-if="u.user.via == 'dana'"> 
                            <img class="icon" src="@/assets/link.png" alt="" style="height: 35px;" v-else-if="u.user.via == 'linkaja'"> 
                          </span>
                        </td>
                        <td>
                          <router-link :to="{ name: 'pelanggan-lunas-detail', params: { id:u.user.uid, user: u.user, area: u.area  }}"  class="text-info" ><i class="material-icons">remove_red_eye</i> Detail</router-link>

                          <!-- <button v-show="isAllow()" @click="showing = index, idHapus = u.user.uid" class="btn btn-sm btn-danger" ><i class="material-icons">delete_outline</i> Hapus</button> -->
                        </td>
                        <td>
                          <transition name="slide-fade" mode="out-in">
                            <button v-if="showing == index" v-show="showing == index" class="btn btn-sm btn-success slide-enter-active" @click="hapusUser(index)"><i class="material-icons">check_circle</i> Ya</button>
                          </transition>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
      </div>
      
      <!-- MODAL -->
			<div class="modal" tabindex="-1" role="dialog" v-show="modalAdmin">
				<div class="overlay"></div>
				<div class="modal-dialog" role="document">
					<div class="modal-content">
						<div class="modal-header">
							<h5 class="modal-title">Pilih Admin</h5>
							<button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="modalAdmin = false">
							  <span aria-hidden="true">&times;</span>
							</button>
						</div>
						<div class="modal-body">
							<div class="row">
                <div class="col-md-12" style="height: 400px;overflow:auto">
                  <div class="table-responsive">
                    <table class="table">
                      <thead class=" text-info">
                        <th>No.</th>
                        <th>Nama</th>
                        <th>Aksi</th>
                      </thead>
                      <tbody>
                        <tr>
                          <td>0</td>
                          <td>{{ namaQ }}</td>
                          <td>
                            <button class="btn btn-sm btn-primary" @click="cariByAdmin(namaQ)"> Pilih</button>
                          </td>
                        </tr>
                        <tr v-for="(u, index) in admin">
                          <td>{{ index+1 }}</td>
                          <td>{{ u.nama }}</td>
                          <td>
                            <button class="btn btn-sm btn-primary" @click="cariByAdmin(u.nama)"> Pilih</button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
							</div>
						</div>
					</div>
				</div>
			</div>
      
      
      <!-- MODAL -->
			<div class="modal" tabindex="-1" role="dialog" v-show="modalArea">
				<div class="overlay"></div>
				<div class="modal-dialog" role="document">
					<div class="modal-content">
						<div class="modal-header">
							<h5 class="modal-title">Pilih Area</h5>
							<button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="modalArea = false">
							  <span aria-hidden="true">&times;</span>
							</button>
						</div>
						<div class="modal-body">
							<div class="row">
                <div class="col-md-12">
                  <div class="table-responsive" style="height:400px;oveflow:auto">
                    <table class="table">
                      <thead class=" text-info">
                        <th>No.</th>
                        <th>Nama</th>
                        <th>Jumlah</th>
                        <th>Aksi</th>
                      </thead>
                      <tbody>
                        <tr v-for="(u, index) in area">
                          <td>{{ index+1 }}</td>
                          <td>{{ u.nama }}</td>
                          <td>{{ u.jumlah }}</td>
                          <td>
                            <button class="btn btn-sm btn-primary" @click="pilihArea(u.id,u.nama)"> Pilih</button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
							</div>
						</div>
					</div>
				</div>
			</div>


    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import vuejsDatepicker from 'vuejs-datepicker'
import inter from '@/globalFunc/Interface' 
import Loading from '@/globalFunc/Loading' 
import myGlobal from '@/globalFunc/myGlobal' 
import { RedisSession } from '@/globalFunc/redis';

import moment from 'moment'
Vue.use(moment)

// EXCEL
import JsonExcel from 'vue-json-excel'
Vue.component('downloadExcel', JsonExcel)

export default {
  name: 'Beranda', 
  components: { 
    vuejsDatepicker,
    moment,
    'Loading': Loading
  },
  data () {
    return {
      loading: true,
      namaQ: '',
      pelanggan: [],
      json_fieldspelanggan: {
        "No" : 'no',
        'Nama': 'nama',
        'Telepon': 'telepon',
        'Paket': 'paket',
        'Area': 'area',
        'Biaya': 'biaya',
        'Tanggal Bayar': 'tanggal',
        'Bulan Tagihan': 'bulan',
        'Admin By': 'admin'
      },
      json_datapelanggan: [],
      json_metapelanggan: [
          [
              {
                  'key': 'charset',
                  'value': 'utf-8'
              }
          ]
      ],

      area: [],
      pelangganCari: [],
      pelangganCariCustom: [],
      cariByTelepon: false,
      
      showing: -1,

      telepon: '',
      bulan: '',

      dariTanggal: '',
      sampaiTanggal: '',
      statuse: '',
      filtered: '',

      // hapus
      idHapus: '',
      
      // cari kurir
      cariPelanggan: '',
      textCariPelanggan: '',
      textSalah: '',
      idPelanggan: '',
      namaPelanggan: '',

      // topup
      topup: '',
      password: '',

      modalAdmin: false,
      admin: [],

      // modal 
      modalArea: false,
      preCari: true,

      isCari: false,
      isCariCustom: false,

      totalHistory: '',
      totalFilter: '',

      filterCustomBox: false,

      areaId: 'null',
      areaName: '',

      judulDoc: '',
      nameDoc: '',

    }
  },
  methods: {
    /*
      ADMIN 
    */
    BulanOnly(date) {      
      var bulan = ['Januari', 'Februari', 'Maret', 'April', 'Mei', 'Juni', 'Juli', 'Agustus', 'September', 'Oktober', 'November', 'Desember'];
      var tgl = new Date(date);
      var kosongJam;
      if (tgl.getHours()<10) {
          kosongJam = "0";
      } else {
          kosongJam = "";
      }
      var kosongMenit;
      if (tgl.getMinutes()<10) {
          kosongMenit = "0";
      } else {
          kosongMenit = "";
      }
      var realBulan = bulan[parseInt(tgl.getMonth())]+' '+tgl.getFullYear();
      
      
      return realBulan;
    },
    byAdmin() {
      this.modalAdmin = true;
    },
    getAdmin() {
      let cacheT = "belum_admin"; // REDIS ====================================
      const cached = RedisSession.get(cacheT);
      if (cached) {
          let x = cached;

          // LANJUT DI BAWAH
          if (x.status) {
            this.admin = x.data;
          } else {
            //alert(x.pesan);
          }

          myGlobal.loger("dari radis "+cacheT);

          return false;
      }
      myGlobal.loger("baru "+cacheT);

      this.isCari = false;

      var data = {
        token: 'TangTung '+sessionStorage.getItem('myToken'),
        is: "tagih"
      }
      
      var apiUrl = inter.AdminList();
      this.PostData(data,apiUrl).then(x => {
        
        RedisSession.set(cacheT, x, 600000); // 10 menit

        if (x.status) {
          this.admin = x.data;

        } else {
          //alert(x.pesan);
        }
      })
    },
    isNullText(x) {
      var a;
      if (x == null) {
        a = "";
      } else {
        a = x
      }
      return a;
    },
    cariByAdmin(nama) {
      var data = new FormData();
      data.append('token', 'TangTung '+sessionStorage.getItem('myToken'));
      data.append('admin', nama);
      data.append('bulan', "0");
      data.append('tahun', sessionStorage.getItem('tahunBase'));
      data.append('type', "lunas");
      data.append('area', "null");
      data.append('tanggal', "null");
      data.append('by', "admin");

      //alert(nama);
      
      var apiUrl = inter.PelangganListCari();
      this.PostData(data,apiUrl).then(x => {
        //console.log(JSON.stringify(x));
        if (x.status == true) {
          this.pelanggan = x.data;
          this.modalAdmin = false;
          this.totalHistory = x.pesan;
          
          var data = x.data;
          var values = [];
          var i;
          for (i = 0; i < data.length; i++) {
              var item1 = {
                  "no" : i+1,
                  'nama' : data[i].user.unama, //this.tglIndo(data[i].due_date)
                  'telepon': data[i].user.wa,
                  'paket': data[i].user.pnama,
                  'area': data[i].area,
                  'biaya': this.ribu(data[i].user.paket_tarif),
                  'tanggal': this.tglIndo(data[i].user.bayar_tanggal),
                  'admin': data[i].user.by_admin
              };
              values.push(item1);
          }
          this.json_datapelanggan = values;          
          this.judulDoc = ["Pelanggan Lunas By "+nama+" - "+this.tglIndo(new Date)];
          this.nameDoc = "Pelanggan Lunas  By "+nama+" - "+this.tglIndo(new Date)+".xls";

        } else {
          //alert(x.pesan);
          this.modalAdmin = false;
          this.textCariPelanggan = x.pesan;
          this.pelanggan = null;
        }
      })
    },
    /*
      ADMIN END
    */
    pilihArea(id,nama) {
      this.areaId = id;
      this.areaName = nama;
      this.modalArea = false;
    },
    showArea() {
      this.modalArea = true

      this.getArea();
    },
    cariCustom() {
      if (this.dariTanggal == "") {
        alert("Silahkan pilih tanggal Dari terlebih dahulu");
        return false;
      }
      if (this.sampaiTanggal == "") {
        alert("Silahkan pilih tanggal Sampai terlebih dahulu");
        return false;
      }

      this.isCariCustom = true;
      this.isCari = true;

      var data = new FormData();
      data.append('token', 'TangTung '+sessionStorage.getItem('myToken'));
      data.append('dari', moment(this.dariTanggal).format('YYYY-MM-DD'));
      data.append('sampai', moment(this.sampaiTanggal).format('YYYY-MM-DD'));
      if (this.areaId != "null") {
        data.append('area', this.areaId);
      }
      
      var apiUrl = 'CariPembayaran';
      this.PostData(data,apiUrl).then(x => {
        this.loger(x);
        if (x.status) {
          this.totalFilter = x.data.total;
          this.pelangganCariCustom = x.data.data;
        } else {
          this.textCariPelanggan = x.pesan;
        }
      })
    },
    filterCustom() {
      this.cariByTelepon = false;
      this.filterCustomBox = true;
    },
    cariPelangganBtn() {
      var data = new FormData();
      data.append('token', 'TangTung '+sessionStorage.getItem('myToken'));
      data.append('cari', this.cariPelanggan);
      data.append('bulan', "0");
      data.append('type', "lunas");
      data.append('area', "null");
      data.append('tanggal', "null");
      
      var apiUrl = 'ListUserCari';
      this.PostData(data,apiUrl).then(x => {
        this.loger(x);
        return false;
        if (x.status) {
          this.preCari = !this.preCari;
          this.idPelanggan = x.data.id;
          this.namaPelanggan = x.data.nama;
        } else {
          //alert(x.pesan);
          this.textCariPelanggan = x.pesan;
        }
      })
    },
    customFormatter (date) {
        return moment(date).format('YYYY-MM-DD');
    },
    cariTelepon() {
      this.filterCustomBox = false;
      this.cariByTelepon = true;
    },
    cariTeleponApi() {
      this.isCari = true;
      var data = new FormData();
      data.append('token', 'TangTung '+sessionStorage.getItem('myToken'));
      data.append('cari', this.telepon);
      data.append('bulan', this.bulan);
      data.append('tahun', sessionStorage.getItem('tahunBase'));
      data.append('type', "lunas_online");
      data.append('area', "null");
      data.append('tanggal', "null");
      data.append('by', "nama");
      
      var apiUrl = inter.PelangganListCari();
      this.PostData(data,apiUrl).then(x => {
        //console.log(JSON.stringify(x));
        if (x.status == true) {
          //this.preCari = !this.preCari;
          //this.idPelanggan = x.data.id;
          //this.namaPelanggan = x.data.nama;

          this.pelanggan = x.data;
        } else {
          //alert(x.pesan);
          this.pelanggan = null;
          this.textCariPelanggan = x.pesan;
        }
      })
    },
    hapusUser(item) {
      
      var data = new FormData();
      data.append('token', 'TangTung '+sessionStorage.getItem('myToken'));
      data.append('id', this.idHapus);
      
      var apiUrl = 'hapusUser';
      this.PostData(data,apiUrl).then(x => {
        if (x.status) {
          this.getData();
          this.showing = -1;
        } else {
          //alert(x.pesan);
        }
      })

    },
    startDownload() {

    },
    getArea() {
      let cacheT = "trxo_area"; // REDIS ====================================
      const cached = RedisSession.get(cacheT);
      if (cached) {
          let x = cached;

          // LANJUT DI BAWAH

          if (x.status) {
            this.area = x.data;
          }

          myGlobal.loger("dari radis "+cacheT);

          return false;
      }
      myGlobal.loger("baru "+cacheT);

      // >> ambil baru

      // for filter
      var data = new FormData();
      data.append('token', 'TangTung '+sessionStorage.getItem('myToken'));
      data.append('type', "lunas_online");
      data.append('bulan', sessionStorage.getItem('bulanIdBase'));
      data.append('tahun', sessionStorage.getItem('tahunBase'));
      
      var apiUrl = inter.ListArea(); // 'ListArea';
      this.PostData(data,apiUrl).then(x => {
        RedisSession.set(cacheT, x, 600000); // 10 menit

        if (x.status) {
          this.area = x.data;
        } else {
          //alert(x.pesan);
        }
      })
    },
    getData() {
      let bulan = sessionStorage.getItem('bulanIdBase');
      let tahun = sessionStorage.getItem('tahunBase');
    
      let cacheT = "pel_lunas_online-"+bulan+"-"+tahun+"-page0"; // REDIS ====================================
      const cached = RedisSession.get(cacheT);
      if (cached) {
          let x = cached;

          // LANJUT DI BAWAH

          this.loading = false;
          if (x.status) {
            this.pelanggan = x.data;
            
          }

          myGlobal.loger("dari radis "+cacheT);

          return false;
      }
      myGlobal.loger("baru "+cacheT);


      this.isCari = false;
      var data = new FormData();
      data.append('token', 'TangTung '+sessionStorage.getItem('myToken'));
      data.append('type', "lunas_online");
      data.append('bulan', bulan);
      data.append('tahun', tahun);

      console.log("TOD "+sessionStorage.getItem('bulanIdBase'));
      console.log(JSON.stringify(data));
      
      var apiUrl = inter.PelangganList();
      this.PostData(data,apiUrl).then(x => {
        
        RedisSession.set(cacheT, x, 300000); // 5 menit

        this.loading = false;

        if (x.status) {
          this.pelanggan = x.data;

        } else {
          //alert(x.pesan);
        }
      })
    },
    
    
    loadAllExcel() {      
      this.isCari = false;
      var data = new FormData();
      data.append('token', 'TangTung '+sessionStorage.getItem('myToken'));
      data.append('type', "lunas_online");
      data.append('page', "all");
      data.append('bulan', sessionStorage.getItem('bulanIdBase'));
      data.append('tahun', sessionStorage.getItem('tahunBase'));

      var apiUrl = inter.PelangganList();
      this.PostData(data,apiUrl).then(x => {
        if (x.status) {
          var data = x.data;
          
          this.totalHistory = x.pesan;
          
          var values = [];
          var i;
          for (i = 0; i < data.length; i++) {
        
              var telepon = data[i].user.wa;
              if (telepon.charAt(0) == "0") {
                telepon = "62"+telepon.substring(1);
              } else if (telepon.charAt(0) == "8") {
                telepon = "62"+telepon;
              }

              var item1 = {
                  "no" : i+1,
                  'nama' : data[i].user.unama, //this.tglIndo(data[i].due_date)
                  'telepon': telepon,
                  'paket': data[i].user.pnama,
                  'area': data[i].area,
                  'biaya': this.ribu(data[i].user.paket_tarif),
                  'tanggal': this.tglIndo(data[i].user.bayar_tanggal),
                  'bulan': this.BulanOnly(data[i].user.tanggal),
                  'admin': data[i].user.by_admin
              };
              values.push(item1);
          }
          this.json_datapelanggan = values;      
          this.judulDoc = ["Pelanggan Lunas Online - "+this.tglIndo(new Date)];
          this.nameDoc = "Pelanggan Lunas Online - "+this.tglIndo(new Date)+".xls";

        } else {
          
        }
      })
    },
  },
  mounted () {
    this.namaQ = sessionStorage.getItem('admin');
    this.getData();
    this.getAdmin();
    //this.loadAllExcel();
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.modal {
	display: inherit;
}
</style>



// WEBPACK FOOTER //
// src/components/pelanggan-lunas/main-online.vue